import React from 'react';
import './PageStyles.css';

const AboutPage: React.FC = () => {
    return (
        <div className="page-container">
            <div className="container">
                <h1 className="page-title">About</h1>
                <div className="page-content">
                    <p>
                        EkamLabs is a product studio focused on building high-quality applications
                        that solve real-world problems.
                    </p>
                    <p>
                        With a background in designing and building high-throughput, low-latency financial
                        systems, we bring deep expertise in distributed architectures, event-driven design,
                        and performance optimization to every project.
                    </p>
                    <p>
                        Our technical foundation includes extensive experience with microservices,
                        cloud infrastructure, and modern development practices. We specialize in systems
                        that process thousands of transactions per second with strict correctness requirements.
                    </p>
                    <p>
                        Our philosophy is grounded in technical excellence, minimalist design, and
                        user-centric development. We believe in shipping products that are not just
                        functional, but delightful to use.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AboutPage;
